import logger from "@/utils/logger";
import API from "@/components/Joyspace/api";
import isEmpty from "lodash/isEmpty";
import {
  FolderTypeNames,
  folderType,
  folderTypeEnum
} from "@/components/Joyspace/config/permissions.config";
import { Order, Sort } from "@/components/Joyspace/components/List/Filters/config";
import { useNavigator } from "@/utils/NetworkCheck";
import { message } from "antd";
import events from "@/components/Joyspace/context/events";
import TagTreeDataInfo from "@/components/Joyspace/components/NavTree/TagTreeDataInfo";
const defaultDataInfo = [
  {
    name: FolderTypeNames.Home,
    to: "/joyspace/home",
    icon: "iconzhuye1",
    id: "home",
    isLeaf: true,
    level: 0
  },
  {
    name: FolderTypeNames.MY,
    to: "/joyspace/myspace",
    icon: "iconwenjian",
    id: "myspace",
    full_path: folderType.MY,
    isLeaf: false,
    type: folderTypeEnum.MY,
    level: 0
  },
  {
    name: FolderTypeNames.SHARE,
    to: "/joyspace/teamspace",
    icon: "icongongxiangwenjian",
    type: folderTypeEnum.SHARE,
    id: folderType.SHARE,
    full_path: folderType.SHARE,
    isLeaf: false,
    level: 0
  },
  {
    withSplit: true,
    name: FolderTypeNames.KNOWLEDGE,
    to: "/joyspace/wiki",
    icon: "iconzhishiku1",
    id: "knowledge",
    isLeaf: true,
    level: 0
  },
  {
    name: FolderTypeNames.TAGS,
    to: "/joyspace/mytags",
    icon: "iconbiaoqian",
    type: FolderTypeNames.TAGS,
    id: FolderTypeNames.TAGS,
    full_path: FolderTypeNames.TAGS,
    isLeaf: false,
    level: 0
  },
  {
    name: FolderTypeNames.COLLECTIONS,
    to: "/joyspace/collections",
    icon: "iconshoucang1",
    id: "collections",
    isLeaf: true,
    level: 0,
    clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|7"
  },
  {
    withSplit: true,
    name: FolderTypeNames.TRASHES,
    to: "/joyspace/trashes",
    icon: "iconquanjushanchu1",
    id: "trashes",
    isLeaf: true,
    level: 0,
    clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|8"
  }
];

export interface FolderInfoRes {
  id: string;
  type?: number | string;
  name: string;
  full_name?: string;
  full_path?: string;
  isLeaf?: boolean;
  [key: string]: any;
}
export interface ChildIdNode {
  id: string;
  children?: ChildIdNode[];
  [key: string]: any;
}
export interface FolderInfoResMap {
  [key: string]: FolderInfoRes;
}
export interface ChildIdMap {
  [key: string]: number;
}
export interface JoyspaceState {
  currentRouterInfo: FolderInfoRes | null;
  error: Error | null;
  folderInfo: FolderInfoRes | null;
  folderInfoMap: FolderInfoResMap | null;
  getFolderInfoById: Function;
  treeDataInfo: [];
  expandedKeys?: [];
  selectedKeys?: [];
  filterInfo: FilterInfoState;
  drageSelectItems?: [];
}
export interface FilterInfoState {
  sort: Sort;
  order: Order;
}
// eslint-disable-next-line max-params
function updateTreeList(
  list: any,
  key: any,
  children: any,
  childIdMap?: ChildIdMap,
  isAdd = false
) {
  const data = list.map((node: any) => {
    if (node.id === key) {
      isAdd && console.log("isAdd111", key, children, [...children, ...node.children]);
      if (childIdMap) {
        const keys = Object.keys(childIdMap);
        const newChildren: ChildIdNode[] = [];
        node?.children?.forEach((element: ChildIdNode) => {
          if (keys.includes(element.id)) {
            newChildren.push(element);
            delete childIdMap[element.id];
          }
        });
        if (newChildren.length === 0) {
          Object.keys(childIdMap).forEach((element) => {
            newChildren.push({
              id: element
            });
          });
        } else {
          Object.keys(childIdMap).forEach((element) => {
            newChildren.unshift({
              id: element
            });
          });
        }

        return {
          ...node,
          children: newChildren
        };
      }
      if (isAdd) {
        return {
          ...node,
          children: [...children, ...node.children]
        };
      }

      return {
        ...node,
        children: children
      };
    }
    if (node.children) {
      return {
        ...node,
        children: updateTreeList(node.children, key, children, childIdMap, isAdd)
      };
    }
    return node;
  });
  return data;
}

function deleteIdInList(list: any[], key: string): boolean {
  for (let i = 0; i < list.length; i++) {
    const node = list[i];
    if (node.id === key) {
      list.splice(i, 1);
      return true;
    }
    const result = deleteIdInList(node.children, key);
    if (result) return result;
  }
  return false;
}
function getfolderInfoMap(list: FolderInfoRes[]) {
  const defaultMap: FolderInfoResMap = {};
  list.forEach((item: FolderInfoRes) => {
    defaultMap[item.id] = item;
  });
  return defaultMap;
}
export default {
  namespace: "joyspace",
  state: {
    currentRouterInfo: null,
    expandedKeys: [],
    selectedKeys: ["home"],
    treeDataInfo: defaultDataInfo,
    folderInfoMap: getfolderInfoMap(defaultDataInfo),
    filterInfo: {
      sort: Sort.UpDateTime,
      order: Order.DESC
    },
    drageSelectItems: [],
    currentPath: ""
  },
  reducers: {
    setExpandedKeys(state: JoyspaceState, { payload }: { payload: any }) {
      return { ...state, expandedKeys: payload };
    },
    setSelectedKeys(state: JoyspaceState, { payload }: { payload: any }) {
      return { ...state, selectedKeys: payload };
    },
    setCurrentPath(state: JoyspaceState, { payload }: { payload: any }) {
      return { ...state, currentPath: payload };
    },
    setDrageSelectItems(state: JoyspaceState, { payload }: { payload: any }) {
      const selectIds = payload;
      const selectItems = selectIds.map((id: string) => {
        return state?.folderInfoMap?.[id] || null;
      });
      return { ...state, drageSelectItems: selectItems };
    },
    // 只支持树结构存储
    updateTreeDataInfo(state: JoyspaceState, { payload }: any) {
      console.log("updateTreeDataInfo111", payload, state.folderInfoMap);
      return { ...state, treeDataInfo: payload };
    },
    setFolderInfo(state: JoyspaceState, { payload }: { payload: FolderInfoRes }) {
      return { ...state, folderInfo: payload };
    },
    setFolderInfoMap(state: JoyspaceState, { payload }: { payload: FolderInfoResMap }) {
      return { ...state, folderInfoMap: payload };
    },
    setCurrentRouterInfo(state: JoyspaceState, { payload }: { payload: FolderInfoRes }) {
      return { ...state, currentRouterInfo: payload };
    },
    setFilter(state: JoyspaceState, { payload }: any) {
      return { ...state, filterInfo: { ...payload } };
    },
    // 清空数据
    clearData(state: JoyspaceState) {
      return {
        ...state,
        currentRouterInfo: null,
        expandedKeys: [],
        selectedKeys: ["home"],
        treeDataInfo: defaultDataInfo,
        folderInfoMap: getfolderInfoMap(defaultDataInfo)
      };
    }
  },
  effects: {
    // 获取当前的文件夹
    *getCurrentRouterInfo({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      // 因为tree组件 不支持id直接赋值为root
      if (joyspaceState.currentRouterInfo.id === "myspace") {
        return {
          ...joyspaceState.currentRouterInfo,
          id: folderType.MY
        };
      }
      return joyspaceState.currentRouterInfo;
    },
    // 设置当前的文件夹
    *setCurrentRouterInfoById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload;
      try {
        if (id === null) {
          yield put({
            type: "setCurrentRouterInfo",
            payload: null
          });
          // yield put({
          //     type: 'setSelectedKeys',
          //     payload: ['home'],
          // });
          return;
        }

        yield put({
          type: "setSelectedKeys",
          payload: [id]
        });
        let itemInfo = joyspaceState.folderInfoMap?.[id];
        const hasInMap = !!itemInfo;
        let res;
        // 打开文件夹除去我的文件和共享文件都更新info数据
        if (![folderType.SHARE, "myspace"].includes(itemInfo?.id) && useNavigator.onLine) {
          // 因为最外层肯定存在所以不用重写id
          res = yield call(API.categories.infoWithAuth, id);
          itemInfo = res;
          // eslint-disable-next-line no-debugger
          // debugger;
          console.log(res, "resres111");
          if (!res) {
            // 已经处理了跳转了
            return;
          }
          let folderInfoMap = {
            ...joyspaceState.folderInfoMap,
            [id]: res
          };

          yield put({
            type: "setFolderInfoMap",
            payload: {
              ...folderInfoMap
            }
          });
        }
        const storeId = joyspaceState.currentRouterInfo?.id;

        if (!itemInfo) {
          throw new Error("itemInfoEmpty");
        }
        yield put({
          type: "setCurrentRouterInfo",
          payload: itemInfo
        });
        if (!("parent" in itemInfo)) {
          return;
        }
        const pid = itemInfo.parent
          ? itemInfo.parent.includes("$")
            ? "myspace"
            : itemInfo.parent
          : folderType.SHARE;
        console.log(pid, "pid111");
        if (!hasInMap && res && joyspaceState.expandedKeys.includes(pid)) {
          console.log(3);
          const updateTreeData = updateTreeList(
            joyspaceState.treeDataInfo,
            pid,
            [{ id: id }],
            undefined,
            true
          );
          yield put({
            type: "updateTreeDataInfo",
            payload: [...updateTreeData]
          });
          // yield put({
          //   type: "freshFolderTreeById",
          //   payload: {
          //     pid
          //   }
          // });
        }
        // 只有通过父文件夹里点击过来的才展开左侧列表
        if (!joyspaceState.expandedKeys.includes(pid) && id && storeId === pid) {
          yield put({
            type: "setExpandedKeys",
            payload: joyspaceState.expandedKeys.concat(pid)
          });
        }
      } catch (e) {
        console.error("openFolderError", e);
        events.emit("joyspace:location", `/joyspace/error?code=openFolderError&folderId=${id}`);
      }
    },
    // 设置当前的文件夹可能没有文件夹信息
    *goToFolderById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);

      const id = payload;
      if (id === null) {
        yield put({
          type: "setCurrentRouterInfo",
          payload: null
        });
        // yield put({
        //     type: 'setSelectedKeys',
        //     payload: ['home'],
        // });
        return;
      }
      const itemInfo = joyspaceState.folderInfoMap?.[id];
      if (itemInfo) {
        yield put({
          type: "setCurrentRouterInfoById",
          payload: id
        });
      } else {
        console.log("数据出错", id, joyspaceState.folderInfoMap);
      }
    },

    // 获取子文件夹
    *getFolderInfoById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload.id;

      if (!id) {
        return false;
      }

      let res;
      try {
        const useSpaceId = id === "myspace" ? "root" : id;
        res = yield call(API.pages.getFileList, useSpaceId, payload.params);
        console.log(res, "resres");
      } catch (e) {
        console.log(e, "errrrrrrrrrrr");
        return Promise.reject(e);
      }
      if (!res) {
        return [];
      }
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };
      const childrenIds: ChildIdNode[] = [];
      res.forEach((element: FolderInfoRes) => {
        folderInfoMap[element.id] = element;
        childrenIds.push({
          id: element.id
        });
      });
      // if (joyspaceState.expandedKeys.includes(id)) {
      console.log(4);
      const updateTreeData = updateTreeList(joyspaceState.treeDataInfo, id, childrenIds);
      yield put({
        type: "updateTreeDataInfo",
        payload: updateTreeData
      });
      // }
      console.log();
      yield put({
        type: "setFolderInfoMap",
        payload: {
          ...folderInfoMap
        }
      });
      return res;
    },
    // 获取标签
    *getTags({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);

      let res;
      try {
        res = yield call(API.tags.queryTags);
        let folderInfoMap = {
          ...joyspaceState.folderInfoMap
        };
        // const childrenIds: ChildIdNode[] = [];
        const treeDataInfo = joyspaceState.treeDataInfo;
        const index = treeDataInfo.findIndex(
          (data: TagTreeDataInfo) => data.type === FolderTypeNames.TAGS
        );
        treeDataInfo[index].children = [];
        res?.items?.forEach((element: any) => {
          folderInfoMap[element.id] = new TagTreeDataInfo({
            id: element.id,
            name: element.name,
            count: element.count
          });
          treeDataInfo[index].children.push({
            id: element.id
          });
        });
        yield put({
          type: "updateTreeDataInfo",
          payload: [...treeDataInfo]
        });
        // }
        console.log();
        yield put({
          type: "setFolderInfoMap",
          payload: {
            ...folderInfoMap
          }
        });
        return res;
      } catch (e) {
        console.log(e, "errrrrrrrrrrr");
        return Promise.reject(e);
      }
      // if (!res) {
      //   return [];
      // }
      // return res;
    },
    // 获取文件夹内容信息
    *getFolderInfo({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload?.id;
      if (!id) return null;
      return joyspaceState.folderInfoMap?.[id] || null;
    },

    // 文件列表刷新tree数据，只增加删除节点，不改变里面的
    *freshFolderTreeById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload.id;

      if (!id) {
        return false;
      }

      let res;

      try {
        const useSpaceId = id === "myspace" ? "root" : id;
        res = yield call(API.pages.getFileList, useSpaceId, payload.params);
      } catch (e) {
        return Promise.reject(e);
      }
      if (!res) {
        return [];
      }
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };

      const childrenIds: ChildIdNode[] = [];
      const childIdMap: ChildIdMap = {};
      res.forEach((element: FolderInfoRes) => {
        folderInfoMap[element.id] = element;
        childIdMap[element.id] = 1;
        childrenIds.push({
          id: element.id
        });
      });

      const leftTree = id === "root" ? "myspace" : id;
      console.log(childIdMap, childrenIds, leftTree, "updateTreeData====>1");
      const updateTreeData = updateTreeList(
        joyspaceState.treeDataInfo,
        leftTree,
        childrenIds,
        childIdMap
      );
      console.log(updateTreeData, "updateTreeData====>2");
      yield put({
        type: "updateTreeDataInfo",
        payload: updateTreeData
      });
      // }

      yield put({
        type: "setFolderInfoMap",
        payload: {
          ...folderInfoMap
        }
      });
      return res;
    },
    // 增加map里的数据
    *addFolderInfo({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const list: FolderInfoRes[] = payload.list;
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };
      list.forEach((element: FolderInfoRes) => {
        folderInfoMap[element.id] = element;
      });

      yield put({
        type: "setFolderInfoMap",
        payload: {
          ...folderInfoMap
        }
      });
    },
    // 刷新
    *freshLeftTreeByFolderById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload.id;
      // eslint-disable-next-line no-debugger
      // debugger;
      if (!id) {
        return false;
      }
      yield put({
        type: "freshFolderTreeById",
        payload: {
          id
        }
      });
      // const leftTree = id === "root" ? "myspace" : id;

      // // 只有左侧的
      // if (joyspaceState.expandedKeys.includes(leftTree)) {
      //   yield put({
      //     type: "freshFolderTreeById",
      //     payload: {
      //       id
      //     }
      //   });
      // }
    },
    // 修改tree文件夹,如果是当前选中的文件夹则也更新
    *changeFolderInfoById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload.id;
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };

      if (!id) {
        return false;
      }

      folderInfoMap[id] = {
        ...folderInfoMap[id],
        name: payload.name,
        description: payload.desc
      };
      yield put({
        type: "setFolderInfoMap",
        payload: {
          ...folderInfoMap
        }
      });
      if (joyspaceState.currentRouterInfo?.id === id) {
        yield put({
          type: "setCurrentRouterInfo",
          payload: {
            ...folderInfoMap[id]
          }
        });
      }
    },
    // 删除tree文件夹
    *deleteFolderById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const id = payload.id;
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };

      if (!id) {
        return false;
      }
      delete folderInfoMap[id];

      yield put({
        folderInfoMap,
        type: "setFolderInfoMap",
        payload: {
          ...folderInfoMap
        }
      });
      const treeDataInfo = [...joyspaceState.treeDataInfo];
      if (deleteIdInList(treeDataInfo, id)) {
        yield put({
          type: "updateTreeDataInfo",
          payload: treeDataInfo
        });
      }
    },
    // 删除tree文件夹
    *updataTreeFolderById({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const { id, toId } = payload;
      let treeDataInfo = [...joyspaceState.treeDataInfo];
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };
      // eslint-disable-next-line no-debugger
      // debugger;
      if (!id) {
        return false;
      }
      const folderInfo = folderInfoMap[id];
      if (!folderInfo || folderInfo.type === folderTypeEnum.GROUP) {
        return false;
      }
      // // eslint-disable-next-line no-debugger
      // debugger;
      const rootId = folderInfo.type === folderTypeEnum.MY ? "myspace" : "teamRoot";
      const idx = treeDataInfo.findIndex((item: any) => item.id === rootId);
      if (idx === -1) {
        return false;
      }
      const children = treeDataInfo[idx].children;
      if (!Array.isArray(children)) {
        return false;
      }
      let ids = folderInfo.full_path.split("$@$");
      function deleteTreeFolder(idsArr = [], arr: any[] = []) {
        const id = idsArr[0];
        const idx = arr.findIndex((item: any) => item.id === id);
        if (idx === -1) {
          return false;
        }
        idsArr.splice(0, 1);
        const newItem = arr[idx];
        // const item:any = arr.find((item:any) => item.id === id);
        if (idsArr.length > 0 && Array.isArray(newItem.children) && newItem.children.length > 0) {
          deleteTreeFolder(idsArr, newItem.children);
        } else {
          arr.splice(idx, 1);
        }
      }
      deleteTreeFolder(ids, children);
      console.log(treeDataInfo, folderInfoMap, "folderInfoMap=====>", id, toId);
      if (!toId) {
        yield put({
          type: "updateTreeDataInfo",
          payload: [...treeDataInfo]
        });
        delete folderInfoMap[id];
        yield put({
          type: "setFolderInfoMap",
          payload: {
            ...folderInfoMap
          }
        });
        return;
      }
      const leftTreeId = toId === "root" ? "myspace" : toId;
      yield put({
        type: "freshFolderTreeById",
        payload: {
          id: leftTreeId
        }
      });
    },
    *batchUpdataTreeFolderByIds({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      const { ids, toId } = payload;
      let treeDataInfo = [...joyspaceState.treeDataInfo];
      let folderInfoMap = {
        ...joyspaceState.folderInfoMap
      };
      if (!ids || (Array.isArray(ids) && !ids.length)) {
        return false;
      }
      const id = ids[0];
      const folderInfo = folderInfoMap[id];
      if (!folderInfo || folderInfo.type === folderTypeEnum.GROUP) {
        return false;
      }
      // // eslint-disable-next-line no-debugger
      // debugger;
      const rootId = folderInfo.type === folderTypeEnum.MY ? "myspace" : "teamRoot";
      const idx = treeDataInfo.findIndex((item: any) => item.id === rootId);
      if (idx === -1) {
        return false;
      }
      const children = treeDataInfo[idx].children;
      if (!Array.isArray(children)) {
        return false;
      }
      let _ids = folderInfo.full_path.split("$@$");
      function deleteTreeFolder(idsArr = [], arr: any[] = [], ids: any[] = []) {
        const id = idsArr[0];
        const idx = arr.findIndex((item: any) => item.id === id);
        if (idx === -1) {
          return false;
        }
        idsArr.splice(0, 1);
        const newItem = arr[idx];
        if (idsArr.length > 0 && Array.isArray(newItem.children) && newItem.children.length > 0) {
          deleteTreeFolder(idsArr, newItem.children, ids);
        } else {
          ids.splice(0, 1);
          arr.splice(idx, 1);
          for (let id of ids) {
            const index = arr.findIndex((item: any) => item.id === id);
            arr.splice(index, 1);
          }
        }
      }
      deleteTreeFolder(_ids, children, ids);
      yield put({
        type: "updateTreeDataInfo",
        payload: [...treeDataInfo]
      });
      delete folderInfoMap[id];
      yield put({
        type: "setFolderInfoMap",
        payload: {
          ...folderInfoMap
        }
      });
      if (!toId) {
        return;
      }
      const leftTreeId = toId === "root" ? "myspace" : toId;
      yield put({
        type: "freshFolderTreeById",
        payload: {
          id: leftTreeId
        }
      });
    },
    // 筛选器
    *setFilterInfo({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);

      // const { srot = Sort.UpDateTime, order = Order.DESC } = payload;
      // joyspaceState.filterInfo
      yield put({
        type: "setFilter",
        payload: {
          ...payload
        }
      });
    },
    *updateFolderInfoMap({ payload }: any, { call, put, select }: any): any {
      const joyspaceState = yield select(({ joyspace }: { joyspace: JoyspaceState }) => joyspace);
      yield put({
        type: "setFolderInfoMap",
        payload: {
          ...joyspaceState.folderInfoMap,
          ...payload
        }
      });
    }
  }
};
